export default __webpack_public_path__ + "static/media/JavaScript-Algorithms-and-Data-Structures.fb506c07.png";